module.exports = __webpack_public_path__ + "img/tabc.59161628.png";